export enum DetailType {
  Input = 'input',
  Button = 'button',
  Select = 'select',
}
